const setResourceHost = () => {
  return `${apiRoot}/api/`;
};

const setAssetResourceHost = () => {
  return `${apiRoot}/api`;
};

const apiRoot = window._env_.API_URL || 'http://localhost'
const resourceHost = setResourceHost();
const assetResourceHost = setAssetResourceHost();

const customerCenterHost = window._env_.CUSTOMER_CENTER_URL || 'http://localhost:3001'

const config = {
  apiRoot,

  // resource endpoints
  resourceHost,
  assetResourceHost,
  customerCenterHost
};

export default config;



// WEBPACK FOOTER //
// ./src/config.js